import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Select from '../Select/Select';
import Icon from '../Icon/Icon';
import s from './DeliveryOptions.scss';

const DeliveryOptions = props => {
  const { options, label } = props;
  const { value: defaultSelectValue, icon: defaultSelectedIcon } =
    options?.[0] || {};
  const [selectValue, setSelectValue] = useState(defaultSelectValue);
  const [selectedIcon, setSelectedIcon] = useState(defaultSelectedIcon);
  const onOptionSelect = ({ target: { value } }) => {
    options.forEach(currentOption => {
      if (currentOption.value === value) {
        currentOption.onChange(currentOption.value, value);
        setSelectedIcon(currentOption.icon);
      }
      setSelectValue(value);
    });
  };
  return (
    <div className={cx(s.root)}>
      <div className={cx(s['delivery-select'])}>
        <Select
          options={options}
          onChange={onOptionSelect}
          showLabel="true"
          className={s.formLabel}
          value={selectValue}
          ariaLabel="Delivery method"
          fluid
          tertiary
          label={label}
          left={() => (
            <span>
              <Icon
                role="presentation"
                name={selectedIcon}
                className={s.icon}
              />
            </span>
          )}
        />
      </div>
    </div>
  );
};

DeliveryOptions.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  label: PropTypes.string.isRequired,
};

DeliveryOptions.defaultProps = {};

export default withStyles(s)(DeliveryOptions);
